import { useCallback } from 'react';
import { useIntl, defineMessages } from 'react-intl';

import { NotificationService, NOTIFICATION_TYPE_SUCCESS, NOTIFICATION_TYPE_ERROR } from 'ui-components/services/notification-service';
import * as LtlApi from '@shipstation/client-common/api/ltl.api';

const messages = defineMessages({
  inProgress: {
    id: 'pzOTJR',
    description: 'Notification shown while a pending freight quote cancellation is in progress',
    defaultMessage: 'Deleting quote...',
  },
  success: {
    id: '9/8PTa',
    description: 'Notification shown after a pending freight quote is successfully cancelled',
    defaultMessage: 'Quote Deleted.',
  },
  error: {
    id: 'S3szhk',
    description: 'Notification shown when a pending freight quote cancellation fails',
    defaultMessage: 'Failed to delete quote.',
  },
});

export const useCancelFreightFulfillmentPlan = () => {
  const intl = useIntl();

  return useCallback(
    async (fulfillmentPlanIds: string[]) => {
      const notificationId = NotificationService.showNotification({
        title: intl.formatMessage(messages.inProgress),
        dontHide: true,
      });

      try {
        await LtlApi.cancelFulfillmentPlans({ fulfillmentPlanIds });

        NotificationService.updateNotification(notificationId, {
          title: intl.formatMessage(messages.success),
          notificationType: NOTIFICATION_TYPE_SUCCESS,
          dontHide: false,
        });
        return true;
      } catch (err) {
        const errorMessage = (err as { response?: { data?: string } })?.response?.data ?? intl.formatMessage(messages.error);
        NotificationService.updateNotification(notificationId, {
          title: intl.formatMessage(messages.error),
          content: errorMessage,
          notificationType: NOTIFICATION_TYPE_ERROR,
          dontHide: false,
        });
        return false;
      }
    },
    [intl],
  );
};
